import { all, fork } from 'redux-saga/effects';
import { listPriceSaga } from './list-price';
export function* rootSaga() {
    yield all([fork(listPriceSaga)]);
}
